package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier


@Composable
fun AnimatedVisibilityBox(
    visible: Boolean,
    durationMs: Int = 300,
    content: @Composable () -> Unit
) {
    var isActuallyVisible by remember { mutableStateOf(visible) }

    LaunchedEffect(visible) {
        if (visible) {
            isActuallyVisible = true
        } else {
            kotlinx.coroutines.delay(durationMs.toLong())
            isActuallyVisible = false
        }
    }
    if (isActuallyVisible || visible) {
        Box(
            modifier = Modifier.styleModifier {
                property("transition", "opacity ${durationMs}ms")
                property("opacity", if (visible) "1" else "0")
                property("pointer-events", if (visible) "auto" else "none")
            }
        ) {
            content()
        }
    }
}